const SntText = ({ value }) => {
  return <>{value === undefined || value === null ? "" : value}</>;
};
export default SntText;
